import { useContext } from 'react'
import { AuthorizationContext } from 'src/shared/context'

import { useMutationHook } from './mutationHook'
import { apiPost } from '../config'
import { API_ROUTES } from '../routes'

interface IVerifySmsCodeParams {
  phone: string
  code: string
}

interface IVerifySmsCodeData {
  token: string
}

async function fetchVerifySmsCode(path: string, body: IVerifySmsCodeParams) {
  const { data } = await apiPost<IVerifySmsCodeParams, IVerifySmsCodeData>({ path, body })

  return data
}

export const useVerifySmsCode = () => {
  const { setToken } = useContext(AuthorizationContext)
  const path = API_ROUTES.AUTHOR_AUTH_CHECK_SMS_CODE

  const mutationFn = (url: string, body: IVerifySmsCodeParams) => fetchVerifySmsCode(url, body)
  const onSuccess = (data: IVerifySmsCodeData) => setToken(data.token)

  return useMutationHook({ path, mutationFn, onSuccess })
}
